// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Cp-z","slideIn":"Dp-z"};